export enum JobType {
  items,
  search,
  map,
  cluster,
}

export type ProfessionQuery = {
  description: string
  id: string
  name: string
}

export interface JobTags {
  textTag: any
  keywordTags: string[] | null
  fullTimeTag: any
  partTimeTag: any
  practiceTag?: any
  praktikumTag?: any
  edujobTag?: any
  skillLevel1Tag?: any
  skillLevel2Tag: any
  skillLevel3Tag: any
  clusterTag: any
  avgsTag: any
  radius: any
  month: any
  emailContact?: any
  partnerJobsOnlyTag?: any
  otherJobsTag?: any
  amsjobTag?: any
  workjobTag?: any
  specialjobTag?: any
  minijobTag?: any
  dejobTag?: any
  recruitTag?: any
  tmpjobTag?: any
  timeFactorTag?: any
}

export interface ICountType {
  fulltime: number | null
  parttime: number | null
  praktikum?: number | null
  edujob?: number | null
  minijob?: number | null
  skill_level1: number | null
  skill_level2: number | null
  skill_level3: number | null
  dejob?: number | null
  recruit?: number | null
  tmpjob?: number | null
  partner_jobs_only?: number | null
  other_jobs?: number | null
  amsjob?: number | null
  location_germany?: number | null
  location_netherlands?: number | null
}

export enum CountType {
  fulltime = 'fulltime',
  parttime = 'parttime',
  praktikum = 'praktikum',
  edujob = 'edujob',
  minijob = 'minijob',
  skill_level1 = 'skill_level1',
  skill_level2 = 'skill_level2',
  skill_level3 = 'skill_level3',
  dejob = 'dejob',
  recruit = 'recruit',
  tmpjob = 'tmpjob',
  partner_jobs_only = 'partner_jobs_only',
  other_jobs = 'other_jobs',
  amsjob = 'amsjob',
  location_germany = 'location_germany',
  location_netherlands = 'location_netherlands',
}
